import moment from "moment";
import { Vaccine } from "../../types/pet-screening";
import { useCallback } from "react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";

interface VaccinationTableProps {
  vaccines?: Vaccine[];
}

export const VaccinationTable = ({ vaccines }: VaccinationTableProps) => {
  const isExpired = useCallback((expirationDate?: string) => {
    return expirationDate ? moment(expirationDate).isBefore(moment()) : false;
  }, []);

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-alpha-40">
        <colgroup>
          <col className="w-2/5" />
          <col className="w-1/5" />
          <col className="w-1/5" />
          <col className="w-1/5" />
        </colgroup>

        <thead>
          <tr className="h-12 text-left text-sm text-content-300">
            <th className="p-2 font-medium">Vaccination</th>
            <th className="p-2 font-medium">Vaccination date</th>
            <th className="p-2 font-medium">Expiration date</th>
            <th className="p-2 font-medium"></th>
          </tr>
        </thead>
        <tbody className="divide-y text-sm divide-alpha-40">
          {vaccines?.length ? (
            vaccines.map((vaccine, index) => {
              const isVaccineExpired = isExpired(vaccine.expiration_date);

              return (
                <tr key={`vaccine-${vaccine.type}-${index}`} className="h-12">
                  <td className="p-2 text-sm text-content-1000 font-medium capitalize">
                    {vaccine.type}
                  </td>
                  <td className="p-2 text-sm font-medium text-content-300">
                    {vaccine.vaccination_date
                      ? moment(vaccine.vaccination_date).format("MMM D, YYYY")
                      : "--"}
                  </td>
                  <td className="p-2 text-sm font-medium text-content-300">
                    {vaccine.expiration_date
                      ? moment(vaccine.expiration_date).format("MMM D, YYYY")
                      : "--"}
                  </td>
                  <td className="p-2">
                    <Badge
                      size={BadgeSize.SM}
                      variant={
                        isVaccineExpired
                          ? BadgeVariant.BASE
                          : BadgeVariant.SUCCESS
                      }
                    >
                      {vaccine.vaccination_date && isVaccineExpired
                        ? "Expired"
                        : "Active"}
                    </Badge>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr key="vaccine-no-vaccines" className="h-16">
              <td
                className="p-2 text-sm text-content-300 font-medium text-center capitalize"
                colSpan={4}
              >
                No vaccination records
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
